import Pages from '@pages';
import useKeyboard from '@shared/components/utils/hooks/useKeyboard';
import { pushRoute } from '@shared/store/slices/router.slice';
import { store } from '@shared/store/store';
import { useEffect, useRef } from 'react';

// Helper hook to access back door combination
function useBackDoorCombination() {
  const correctCombination = [
    'UP',
    'DOWN',
    'DOWN',
    'RIGHT',
    'UP',
    'CHANNEL_UP',
  ];
  const currentKeys = useRef<string[]>([]);
  const timeoutRef = useRef<ReturnType<typeof setTimeout> | undefined>(
    undefined
  );

  useEffect(() => {
    return () => {
      clearTimeout(timeoutRef.current);
    };
  });
  useKeyboard({
    canBeFocused: false,
    keyDownHandler: (key) => {
      currentKeys.current.push(key);
      timeoutRef.current = setTimeout(() => {
        currentKeys.current = [];
      }, 5000);

      let success = true;
      for (let i = 0; i < correctCombination.length; i++) {
        if (correctCombination[i] !== currentKeys.current[i]) success = false;
      }
      if (success) {
        store.dispatch(
          pushRoute({
            route: { Page: Pages.BACK_DOOR, overwrite: true },
            params: {},
          })
        );
      }
    },
  });
}

export default useBackDoorCombination;
